import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const API = axios.create({ baseURL: BACKEND_URL });

API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

export default API;